const messages = {
	en: {
		message: {
			workflowDisclaimer: `The recommendations resulting from the use of the Experiment Configurator are
        merely general guidelines. QIAGEN does not assume any liability for the
        information given by the Experiment Configurator or fitness for specific use
        of any suggested configuration. For up-to-date licensing information and
        product-specific disclaimers, see the respective QIAGEN kit handbook or user manual.`,
			shareWorkflowInDevelopment: `You're faster than our developers! Soon you'll be able to click here to
        share experiments and lab notes.`,
			showWfStep: `Show if you want to enable this step`,
			hideWfStep: `Hide if you want to skip this step`,
		},
	},
};

export default messages;
